import { render, staticRenderFns } from "./EmpowerDialog.vue?vue&type=template&id=5952b8f8&scoped=true&"
import script from "./EmpowerDialog.vue?vue&type=script&lang=js&"
export * from "./EmpowerDialog.vue?vue&type=script&lang=js&"
import style0 from "./EmpowerDialog.vue?vue&type=style&index=0&id=5952b8f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5952b8f8",
  null
  
)

export default component.exports